import { useEffect } from 'react'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: (...args: unknown[]) => void
  }
}

export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView')
      return
    }

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    const fbq = (...args: unknown[]) => {
      ;(fbq as unknown as { queue: unknown[][] }).queue.push(args)
    }
    ;(fbq as unknown as { queue: unknown[][] }).queue = []
    window.fbq = fbq
    window._fbq = fbq
    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')
  }, [pixelId])
}
